"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: transfer/transfer-instructions.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftransfer%2Ftransfer-instructions.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferDestinationInternalStepAccountDestinationPurposeToJSON = exports.transferDestinationInternalStepAccountDestinationPurposeFromJSON = exports.TransferDestinationCreditAccountDestination = exports.TransferDestinationInternalStepAccountDestination = exports.TransferDestinationExternalCardDestination = exports.TransferDestinationExternalBankDestination = exports.TransferDestinationTransferRequestDestination = exports.TransferDestinationStepUserDestination = exports.TransferDestinationStepInstallmentLoanDestination = exports.TransferDestinationStepAccountDestination = exports.TransferDestination = exports.TransferSourceEphemeralCardSource = exports.TransferSourceExternalBankSource = exports.TransferSourceExternalCardSource = exports.TransferSourceCashAdvanceSource = exports.TransferSourceStepAccountSource = exports.TransferSource = exports.TransferStep = exports.TransferInstructions = exports.TransferDestinationInternalStepAccountDestinationPurpose = void 0;
const alias_1 = require("../common/alias");
const amount_1 = require("../common/amount");
const external_card_1 = require("../common/external-card");
const external_card_payout_1 = require("../common/external-card-payout");
const protobufPackage = 'com.step.transfer.proto';
var TransferDestinationInternalStepAccountDestinationPurpose;
(function (TransferDestinationInternalStepAccountDestinationPurpose) {
    TransferDestinationInternalStepAccountDestinationPurpose["INVALID_PURPOSE"] = "INVALID_PURPOSE";
    TransferDestinationInternalStepAccountDestinationPurpose["TIPS"] = "TIPS";
    TransferDestinationInternalStepAccountDestinationPurpose["BLACK_SUBSCRIPTION"] = "BLACK_SUBSCRIPTION";
    TransferDestinationInternalStepAccountDestinationPurpose["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransferDestinationInternalStepAccountDestinationPurpose || (exports.TransferDestinationInternalStepAccountDestinationPurpose = TransferDestinationInternalStepAccountDestinationPurpose = {}));
function createBaseTransferInstructions() {
    return { steps: [], description: '' };
}
exports.TransferInstructions = {
    fromJSON(object) {
        const message = {
            steps: globalThis.Array.isArray(object?.steps)
                ? object.steps.map((e) => exports.TransferStep.fromJSON(e))
                : [],
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.steps?.length) {
            obj.steps = message.steps.map((e) => exports.TransferStep.toJSON(e));
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.TransferInstructions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferInstructions();
        message.steps = object.steps?.map((e) => exports.TransferStep.fromPartial(e)) || [];
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseTransferStep() {
    return {
        amount: amount_1.Amount.fromPartial({}),
        source: exports.TransferSource.fromPartial({}),
        destination: exports.TransferDestination.fromPartial({}),
    };
}
exports.TransferStep = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            source: isSet(object.source)
                ? exports.TransferSource.fromJSON(object.source)
                : exports.TransferSource.fromPartial({}),
            destination: isSet(object.destination)
                ? exports.TransferDestination.fromJSON(object.destination)
                : exports.TransferDestination.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.source !== undefined) {
            obj.source = exports.TransferSource.toJSON(message.source);
        }
        if (message.destination !== undefined) {
            obj.destination = exports.TransferDestination.toJSON(message.destination);
        }
        return obj;
    },
    create(base) {
        return exports.TransferStep.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferStep();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.source = (object.source !== undefined && object.source !== null)
            ? exports.TransferSource.fromPartial(object.source)
            : exports.TransferSource.fromPartial({});
        message.destination = (object.destination !== undefined && object.destination !== null)
            ? exports.TransferDestination.fromPartial(object.destination)
            : exports.TransferDestination.fromPartial({});
        return message;
    },
};
function createBaseTransferSource() {
    return {
        stepAccount: undefined,
        cashAdvance: undefined,
        card: undefined,
        bank: undefined,
        ephemeral: undefined,
    };
}
exports.TransferSource = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.stepAccount)) {
            message.stepAccount = exports.TransferSourceStepAccountSource.fromJSON(object.stepAccount);
        }
        if (isSet(object.cashAdvance)) {
            message.cashAdvance = exports.TransferSourceCashAdvanceSource.fromJSON(object.cashAdvance);
        }
        if (isSet(object.card)) {
            message.card = exports.TransferSourceExternalCardSource.fromJSON(object.card);
        }
        if (isSet(object.bank)) {
            message.bank = exports.TransferSourceExternalBankSource.fromJSON(object.bank);
        }
        if (isSet(object.ephemeral)) {
            message.ephemeral = exports.TransferSourceEphemeralCardSource.fromJSON(object.ephemeral);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.stepAccount !== undefined) {
            obj.stepAccount = exports.TransferSourceStepAccountSource.toJSON(message.stepAccount);
        }
        if (message.cashAdvance !== undefined) {
            obj.cashAdvance = exports.TransferSourceCashAdvanceSource.toJSON(message.cashAdvance);
        }
        if (message.card !== undefined) {
            obj.card = exports.TransferSourceExternalCardSource.toJSON(message.card);
        }
        if (message.bank !== undefined) {
            obj.bank = exports.TransferSourceExternalBankSource.toJSON(message.bank);
        }
        if (message.ephemeral !== undefined) {
            obj.ephemeral = exports.TransferSourceEphemeralCardSource.toJSON(message.ephemeral);
        }
        return obj;
    },
    create(base) {
        return exports.TransferSource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferSource();
        message.stepAccount = (object.stepAccount !== undefined && object.stepAccount !== null)
            ? exports.TransferSourceStepAccountSource.fromPartial(object.stepAccount)
            : undefined;
        message.cashAdvance = (object.cashAdvance !== undefined && object.cashAdvance !== null)
            ? exports.TransferSourceCashAdvanceSource.fromPartial(object.cashAdvance)
            : undefined;
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.TransferSourceExternalCardSource.fromPartial(object.card)
            : undefined;
        message.bank = (object.bank !== undefined && object.bank !== null)
            ? exports.TransferSourceExternalBankSource.fromPartial(object.bank)
            : undefined;
        message.ephemeral = (object.ephemeral !== undefined && object.ephemeral !== null)
            ? exports.TransferSourceEphemeralCardSource.fromPartial(object.ephemeral)
            : undefined;
        return message;
    },
};
function createBaseTransferSourceStepAccountSource() {
    return { accountId: '' };
}
exports.TransferSourceStepAccountSource = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferSourceStepAccountSource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferSourceStepAccountSource();
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseTransferSourceCashAdvanceSource() {
    return { accountId: '' };
}
exports.TransferSourceCashAdvanceSource = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferSourceCashAdvanceSource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferSourceCashAdvanceSource();
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseTransferSourceExternalCardSource() {
    return { externalAccountId: '', fee: undefined, cvv: '' };
}
exports.TransferSourceExternalCardSource = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
        };
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        if (isSet(object.cvv)) {
            message.cvv = globalThis.String(object.cvv);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.cvv !== undefined && message.cvv !== '') {
            obj.cvv = message.cvv;
        }
        return obj;
    },
    create(base) {
        return exports.TransferSourceExternalCardSource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferSourceExternalCardSource();
        message.externalAccountId = object.externalAccountId ?? '';
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        message.cvv = object.cvv ?? '';
        return message;
    },
};
function createBaseTransferSourceExternalBankSource() {
    return { externalAccountId: '', fee: undefined };
}
exports.TransferSourceExternalBankSource = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
        };
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        return obj;
    },
    create(base) {
        return exports.TransferSourceExternalBankSource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferSourceExternalBankSource();
        message.externalAccountId = object.externalAccountId ?? '';
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        return message;
    },
};
function createBaseTransferSourceEphemeralCardSource() {
    return { token: external_card_1.CardToken.fromPartial({}), fee: undefined };
}
exports.TransferSourceEphemeralCardSource = {
    fromJSON(object) {
        const message = {
            token: isSet(object.token) ? external_card_1.CardToken.fromJSON(object.token) : external_card_1.CardToken.fromPartial({}),
        };
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== undefined) {
            obj.token = external_card_1.CardToken.toJSON(message.token);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        return obj;
    },
    create(base) {
        return exports.TransferSourceEphemeralCardSource.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferSourceEphemeralCardSource();
        message.token = (object.token !== undefined && object.token !== null)
            ? external_card_1.CardToken.fromPartial(object.token)
            : external_card_1.CardToken.fromPartial({});
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        return message;
    },
};
function createBaseTransferDestination() {
    return {
        stepAccount: undefined,
        stepInstallmentLoan: undefined,
        stepUser: undefined,
        transferRequest: undefined,
        bank: undefined,
        card: undefined,
        internalStepAccount: undefined,
        creditAccount: undefined,
    };
}
exports.TransferDestination = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.stepAccount)) {
            message.stepAccount = exports.TransferDestinationStepAccountDestination.fromJSON(object.stepAccount);
        }
        if (isSet(object.stepInstallmentLoan)) {
            message.stepInstallmentLoan = exports.TransferDestinationStepInstallmentLoanDestination.fromJSON(object.stepInstallmentLoan);
        }
        if (isSet(object.stepUser)) {
            message.stepUser = exports.TransferDestinationStepUserDestination.fromJSON(object.stepUser);
        }
        if (isSet(object.transferRequest)) {
            message.transferRequest = exports.TransferDestinationTransferRequestDestination.fromJSON(object.transferRequest);
        }
        if (isSet(object.bank)) {
            message.bank = exports.TransferDestinationExternalBankDestination.fromJSON(object.bank);
        }
        if (isSet(object.card)) {
            message.card = exports.TransferDestinationExternalCardDestination.fromJSON(object.card);
        }
        if (isSet(object.internalStepAccount)) {
            message.internalStepAccount = exports.TransferDestinationInternalStepAccountDestination.fromJSON(object.internalStepAccount);
        }
        if (isSet(object.creditAccount)) {
            message.creditAccount = exports.TransferDestinationCreditAccountDestination.fromJSON(object.creditAccount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.stepAccount !== undefined) {
            obj.stepAccount = exports.TransferDestinationStepAccountDestination.toJSON(message.stepAccount);
        }
        if (message.stepInstallmentLoan !== undefined) {
            obj.stepInstallmentLoan = exports.TransferDestinationStepInstallmentLoanDestination.toJSON(message.stepInstallmentLoan);
        }
        if (message.stepUser !== undefined) {
            obj.stepUser = exports.TransferDestinationStepUserDestination.toJSON(message.stepUser);
        }
        if (message.transferRequest !== undefined) {
            obj.transferRequest = exports.TransferDestinationTransferRequestDestination.toJSON(message.transferRequest);
        }
        if (message.bank !== undefined) {
            obj.bank = exports.TransferDestinationExternalBankDestination.toJSON(message.bank);
        }
        if (message.card !== undefined) {
            obj.card = exports.TransferDestinationExternalCardDestination.toJSON(message.card);
        }
        if (message.internalStepAccount !== undefined) {
            obj.internalStepAccount = exports.TransferDestinationInternalStepAccountDestination.toJSON(message.internalStepAccount);
        }
        if (message.creditAccount !== undefined) {
            obj.creditAccount = exports.TransferDestinationCreditAccountDestination.toJSON(message.creditAccount);
        }
        return obj;
    },
    create(base) {
        return exports.TransferDestination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferDestination();
        message.stepAccount = (object.stepAccount !== undefined && object.stepAccount !== null)
            ? exports.TransferDestinationStepAccountDestination.fromPartial(object.stepAccount)
            : undefined;
        message.stepInstallmentLoan =
            (object.stepInstallmentLoan !== undefined && object.stepInstallmentLoan !== null)
                ? exports.TransferDestinationStepInstallmentLoanDestination.fromPartial(object.stepInstallmentLoan)
                : undefined;
        message.stepUser = (object.stepUser !== undefined && object.stepUser !== null)
            ? exports.TransferDestinationStepUserDestination.fromPartial(object.stepUser)
            : undefined;
        message.transferRequest =
            (object.transferRequest !== undefined && object.transferRequest !== null)
                ? exports.TransferDestinationTransferRequestDestination.fromPartial(object.transferRequest)
                : undefined;
        message.bank = (object.bank !== undefined && object.bank !== null)
            ? exports.TransferDestinationExternalBankDestination.fromPartial(object.bank)
            : undefined;
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.TransferDestinationExternalCardDestination.fromPartial(object.card)
            : undefined;
        message.internalStepAccount =
            (object.internalStepAccount !== undefined && object.internalStepAccount !== null)
                ? exports.TransferDestinationInternalStepAccountDestination.fromPartial(object.internalStepAccount)
                : undefined;
        message.creditAccount = (object.creditAccount !== undefined && object.creditAccount !== null)
            ? exports.TransferDestinationCreditAccountDestination.fromPartial(object.creditAccount)
            : undefined;
        return message;
    },
};
function createBaseTransferDestinationStepAccountDestination() {
    return { accountId: '' };
}
exports.TransferDestinationStepAccountDestination = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferDestinationStepAccountDestination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferDestinationStepAccountDestination();
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseTransferDestinationStepInstallmentLoanDestination() {
    return { accountId: '', payments: [] };
}
exports.TransferDestinationStepInstallmentLoanDestination = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        if (globalThis.Array.isArray(object?.payments)) {
            message.payments = object.payments.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.payments?.length) {
            obj.payments = message.payments;
        }
        return obj;
    },
    create(base) {
        return exports.TransferDestinationStepInstallmentLoanDestination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferDestinationStepInstallmentLoanDestination();
        message.accountId = object.accountId ?? '';
        message.payments = object.payments?.map((e) => e) || [];
        return message;
    },
};
function createBaseTransferDestinationStepUserDestination() {
    return {
        alias: alias_1.Alias.fromPartial({}),
        accountId: '',
        reimburseTransactionId: '',
        primaryAccountId: '',
    };
}
exports.TransferDestinationStepUserDestination = {
    fromJSON(object) {
        const message = {
            alias: isSet(object.alias) ? alias_1.Alias.fromJSON(object.alias) : alias_1.Alias.fromPartial({}),
        };
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        if (isSet(object.reimburseTransactionId)) {
            message.reimburseTransactionId = globalThis.String(object.reimburseTransactionId);
        }
        if (isSet(object.primaryAccountId)) {
            message.primaryAccountId = globalThis.String(object.primaryAccountId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.reimburseTransactionId !== undefined && message.reimburseTransactionId !== '') {
            obj.reimburseTransactionId = message.reimburseTransactionId;
        }
        if (message.primaryAccountId !== undefined && message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferDestinationStepUserDestination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferDestinationStepUserDestination();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : alias_1.Alias.fromPartial({});
        message.accountId = object.accountId ?? '';
        message.reimburseTransactionId = object.reimburseTransactionId ?? '';
        message.primaryAccountId = object.primaryAccountId ?? '';
        return message;
    },
};
function createBaseTransferDestinationTransferRequestDestination() {
    return { requestId: '' };
}
exports.TransferDestinationTransferRequestDestination = {
    fromJSON(object) {
        const message = {
            requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.requestId !== '') {
            obj.requestId = message.requestId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferDestinationTransferRequestDestination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferDestinationTransferRequestDestination();
        message.requestId = object.requestId ?? '';
        return message;
    },
};
function createBaseTransferDestinationExternalBankDestination() {
    return { externalAccountId: '' };
}
exports.TransferDestinationExternalBankDestination = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferDestinationExternalBankDestination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferDestinationExternalBankDestination();
        message.externalAccountId = object.externalAccountId ?? '';
        return message;
    },
};
function createBaseTransferDestinationExternalCardDestination() {
    return {
        externalAccountId: '',
        fee: undefined,
        payoutMethod: external_card_payout_1.PayoutMethod.INVALID_AVAILABLE_PAYOUT_METHOD,
    };
}
exports.TransferDestinationExternalCardDestination = {
    fromJSON(object) {
        const message = {
            externalAccountId: isSet(object.externalAccountId)
                ? globalThis.String(object.externalAccountId)
                : '',
        };
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        if (isSet(object.payoutMethod)) {
            message.payoutMethod = (0, external_card_payout_1.payoutMethodFromJSON)(object.payoutMethod);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalAccountId !== '') {
            obj.externalAccountId = message.externalAccountId;
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.payoutMethod !== undefined &&
            message.payoutMethod !== external_card_payout_1.PayoutMethod.INVALID_AVAILABLE_PAYOUT_METHOD) {
            obj.payoutMethod = (0, external_card_payout_1.payoutMethodToJSON)(message.payoutMethod);
        }
        return obj;
    },
    create(base) {
        return exports.TransferDestinationExternalCardDestination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferDestinationExternalCardDestination();
        message.externalAccountId = object.externalAccountId ?? '';
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        message.payoutMethod = object.payoutMethod ?? external_card_payout_1.PayoutMethod.INVALID_AVAILABLE_PAYOUT_METHOD;
        return message;
    },
};
function createBaseTransferDestinationInternalStepAccountDestination() {
    return { purpose: TransferDestinationInternalStepAccountDestinationPurpose.INVALID_PURPOSE };
}
exports.TransferDestinationInternalStepAccountDestination = {
    fromJSON(object) {
        const message = {
            purpose: isSet(object.purpose)
                ? transferDestinationInternalStepAccountDestinationPurposeFromJSON(object.purpose)
                : TransferDestinationInternalStepAccountDestinationPurpose.INVALID_PURPOSE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purpose !== TransferDestinationInternalStepAccountDestinationPurpose.INVALID_PURPOSE) {
            obj.purpose = transferDestinationInternalStepAccountDestinationPurposeToJSON(message.purpose);
        }
        return obj;
    },
    create(base) {
        return exports.TransferDestinationInternalStepAccountDestination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferDestinationInternalStepAccountDestination();
        message.purpose = object.purpose ??
            TransferDestinationInternalStepAccountDestinationPurpose.INVALID_PURPOSE;
        return message;
    },
};
function createBaseTransferDestinationCreditAccountDestination() {
    return { primaryAccountId: '' };
}
exports.TransferDestinationCreditAccountDestination = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        return obj;
    },
    create(base) {
        return exports.TransferDestinationCreditAccountDestination.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferDestinationCreditAccountDestination();
        message.primaryAccountId = object.primaryAccountId ?? '';
        return message;
    },
};
function transferDestinationInternalStepAccountDestinationPurposeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PURPOSE':
            return TransferDestinationInternalStepAccountDestinationPurpose.INVALID_PURPOSE;
        case 1:
        case 'TIPS':
            return TransferDestinationInternalStepAccountDestinationPurpose.TIPS;
        case 2:
        case 'BLACK_SUBSCRIPTION':
            return TransferDestinationInternalStepAccountDestinationPurpose.BLACK_SUBSCRIPTION;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransferDestinationInternalStepAccountDestinationPurpose.UNRECOGNIZED;
    }
}
exports.transferDestinationInternalStepAccountDestinationPurposeFromJSON = transferDestinationInternalStepAccountDestinationPurposeFromJSON;
function transferDestinationInternalStepAccountDestinationPurposeToJSON(object) {
    switch (object) {
        case TransferDestinationInternalStepAccountDestinationPurpose.INVALID_PURPOSE:
            return 'INVALID_PURPOSE';
        case TransferDestinationInternalStepAccountDestinationPurpose.TIPS:
            return 'TIPS';
        case TransferDestinationInternalStepAccountDestinationPurpose.BLACK_SUBSCRIPTION:
            return 'BLACK_SUBSCRIPTION';
        case TransferDestinationInternalStepAccountDestinationPurpose.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transferDestinationInternalStepAccountDestinationPurposeToJSON = transferDestinationInternalStepAccountDestinationPurposeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=transfer-instructions.js.map